import { UpgradeAccountState } from '../models';

export const defaultUpgrade: UpgradeAccountState = {
  isUpgradeAccountOpen: false,
  showRequestQuoteForm: false,
};
